import { createContext } from 'react'

export const ColorMappingContext = createContext({
    colorMapping: new Map<string, string>(),
    setColorMapping: (value: Map<string, string>) => { }
})